import Icon from '../../Utilites/Icon';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * ListenPlay component for 'listen' quiz type.
 * Props:
 * - question: aktuální otázka (obsahuje options, audio, correctIndex, ...)
 * - handleAnswer: funkce pro vyhodnocení odpovědi
 * - answerStatus: stav odpovědi (správně/špatně)
 * - onNext: callback pro další otázku
 */


const ListenPlay = ({ question, handleAnswer, answerStatus, onNext }) => {
    const { t } = useTranslation();
    // selected je redundantní, použijeme přímo question.userAnswer

    useEffect(() => {
        let audio;
        // Přehrát zvuk pouze pokud otázka není zodpovězena
        if (question && question.audio && question.status === null) {
            audio = new Audio(question.audio);
            audio.play();
        }
        return () => {
            if (audio) {
                audio.pause();
                audio.currentTime = 0;
            }
        };
    }, [question]);

    if (!question) return null;

    const playAudio = () => {
        if (question.audio) {
            const audio = new Audio(question.audio);
            audio.play();
        }
    };

    const handleClick = (idx) => {
        if (typeof question.userAnswer === 'number') return; // už odpověděl
        // Změna: nejprve vizuální feedback, pak vyhodnocení a přechod
        setTimeout(() => {
            handleAnswer(idx);
            setTimeout(() => {
                if (onNext) onNext();
            }, 800);
        }, 50); // krátké zpoždění pro vizuální efekt
    };

    return (
        <div className="listen-play">
            <div className="grid grid-cols-3 gap-2 max-w-[430px] mx-auto">
                {question.options.map((img, idx) => {
                    let borderClass = 'border-primary';
                    if (question.status !== null && question.userAnswer === idx) {
                        borderClass = question.status === 'correct' ? 'border-green' : 'border-red';
                    }
                    return (
                        <button
                            key={idx}
                            className={`listen-img-btn transition-all duration-200 ${borderClass} ${typeof question.userAnswer === 'number' ? 'pointer-events-none' : ''}`}
                            onClick={() => handleClick(idx)}
                        >
                            <img src={img} alt="option" className="w-32 h-32 object-cover bg-white" />
                        </button>
                    );
                })}
            </div>
            <div className="my-4 text-center text-2xl font-bold"> 
                 {t('quiz-listen-question')}
            </div>
            <div className="flex justify-center mb-4">
                <button className="btn btn-primary" onClick={playAudio}>
                    <Icon name="volume_up" /> {t('play-sound-again')}
                </button>
            </div>          
           
        </div>
    );
};

export default ListenPlay;
